//let env = location.host.indexOf("localhost") > -1 ? "local" : location.host.indexOf("dev-usermanagement.ucn.net") > -1 ? "dev" : location.host.indexOf("qa-usermanagement.ucn.net") > -1 ? "qa" : location.host.indexOf("stg-usermanagement.ucn.net") > -1 ? "stg" : "prod";
//let uri = env == "local" ? "https://localhost:44310/" : env == "dev" ? "https://dev-usermanagement.ucn.net/" : env == "qa" ? "https://qa-usermanagement.ucn.net/" : env == "stg" ? "https://stg-usermanagement.ucn.net/" : "https://usermanagement.niceincontact.com/";
//let authority = env == "local" ? "https://dev-icids.ucn.net/identity" : env == "dev" ? "https://dev-icids.ucn.net/identity" : env == "qa" ? "https://qa-icids.ucn.net/identity" : env == "stg" ? "https://stg-icids.ucn.net/identity" : "https://icids.ucn.net/identity";
//let clientId = env == "local" ? "UserManagementLocalhost" : "UserManagement";

import enviromentVariable from '../constants/enviromentVariable'
export const oidcSettings = {
    authority: enviromentVariable.authority,
    clientId: enviromentVariable.clientId,
    redirectUri: enviromentVariable.uri + 'callback',
    responseType: 'id_token',
    scope: 'openid profile UserManagementScope',
    //postLogoutRedirectUri: enviromentVariable.uri + '?postLogout=true',
    automaticSilentRenew: true,
    automaticSilentSignin: true,
    silentRedirectUri: enviromentVariable.uri + 'silent-renew-oidc.html'
}